export const Donut = () => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.4074 10.4173C14.9303 11.5456 14.1841 12.5399 13.2339 13.3132C12.2837 14.0865 11.1586 14.6153 9.9569 14.8533C8.75518 15.0913 7.51345 15.0313 6.34028 14.6785C5.75469 14.5025 5.19507 14.2561 4.67306 13.9464M5.50019 0.622559C4.37738 1.11253 3.39169 1.8701 2.6293 2.82902C1.8669 3.78795 1.35102 4.91903 1.12675 6.12339C0.902476 7.32775 0.976645 8.56872 1.34277 9.73779C1.52861 10.3312 1.7868 10.8969 2.10995 11.4228"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6998 7.49981C15.8655 7.49981 16.0004 7.36544 15.9938 7.19988C15.9585 6.31737 15.7675 5.4472 15.4289 4.62976C15.052 3.71984 14.4996 2.89306 13.8032 2.19664C13.1067 1.50022 12.28 0.94779 11.3701 0.570889C10.5526 0.232293 9.68244 0.0413193 8.79993 0.0059993C8.63437 -0.000626448 8.5 0.134315 8.5 0.3V7.19981C8.5 7.36549 8.63431 7.49981 8.8 7.49981H15.6998Z"
        fill="currentColor"
      />
    </svg>
  )
}
